var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !!_vm.selectedCell
    ? _c("div", { staticStyle: { height: "100%", position: "relative" } }, [
        _c(
          "div",
          {
            staticClass:
              "is-flex is-justify-content-space-between booking-header",
          },
          [
            _c("span", [_vm._v("Bookings")]),
            _c("span", [_vm._v(_vm._s(_vm.totalBookings() || 0))]),
            _c(
              "div",
              {
                staticStyle: {
                  position: "absolute",
                  top: "-3px",
                  left: "-46px",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("handleSidePanelToggle")
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "side-panel-slide-button is-flex is-align-items-center is-justify-content-center",
                  },
                  [
                    _c("span", {
                      staticClass: "mdi mdi-30px",
                      class: {
                        "mdi-chevron-left": !_vm.isSidePanelOpen,
                        "mdi-chevron-right": _vm.isSidePanelOpen,
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "control has-icons-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchTextField,
                  expression: "searchTextField",
                },
              ],
              staticClass: "input is-capitalized",
              attrs: { type: "text", placeholder: "Search" },
              domProps: { value: _vm.searchTextField },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.onSearch()
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.searchTextField = $event.target.value
                },
              },
            }),
            !!_vm.searchTextField
              ? _c(
                  "span",
                  {
                    staticClass: "icon is-right is-clickable",
                    on: { click: _vm.clearSearch },
                  },
                  [_c("i", { staticClass: "mdi mdi-close has-text-white" })]
                )
              : _vm._e(),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass:
              "mb-2 is-flex is-justify-content-center is-align-items-center",
          },
          [
            _c("hr", { staticClass: "is-flex is-flex-grow-1" }),
            _c("span", { staticClass: "m-2" }, [
              _vm._v(
                _vm._s(
                  _vm.selectedCell?.length > 1
                    ? "Week Summary"
                    : _vm.selectedCell[0].dateString
                )
              ),
            ]),
            _c("hr", { staticClass: "is-flex is-flex-grow-1" }),
          ]
        ),
        _c(
          "div",
          { staticClass: "quote-card-section" },
          _vm._l(_vm.filteredBookings, function (bookings) {
            return _c(
              "div",
              {
                key: bookings.jobNumber,
                staticClass: "card mb-4",
                class: `calendar-quote-card-background-${_vm.$theme.name}`,
                on: {
                  click: function ($event) {
                    return _vm.handleQuoteRedirect(bookings)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "card-content p-2 is-flex is-justify-content-space-between",
                  },
                  [
                    _c("span", [
                      _c("div", [_vm._v("#" + _vm._s(bookings.quoteNoRef))]),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatDateTimeLocale(
                            bookings.jobStart,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "card-content p-2 has-background-warning has-text-black is-size-7",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "is-flex is-justify-content-space-between",
                      },
                      [
                        _c("span", [_vm._v(_vm._s(bookings.owner))]),
                        _c("span", [_vm._v(_vm._s(bookings.insurer))]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "is-flex is-justify-content-space-between",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "is-flex is-flex-direction-column" },
                          [
                            _c("span", [_vm._v(_vm._s(bookings.rego))]),
                            _c("span", [_vm._v(_vm._s(bookings.makeModel))]),
                          ]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                bookings.totalIncGst,
                                _vm.$userInfo.locale,
                                false,
                                2
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }